import { createContext, useContext } from 'react';

import { createRelatoriosDinamicosGenericService } from '../service';

export type RelatoriosDinamicosContextValues = {
  progressInterval?: number;
  service: ReturnType<typeof createRelatoriosDinamicosGenericService>;
};
const RelatoriosDinamicosContext =
  createContext<RelatoriosDinamicosContextValues>(
    {} as RelatoriosDinamicosContextValues
  );

export const RelatoriosDinamicosContextProvider = ({
  progressInterval = 5000,
  service,
  children
}: RelatoriosDinamicosContextValues & { children: React.ReactNode }) => {
  return (
    <RelatoriosDinamicosContext.Provider value={{ progressInterval, service }}>
      {children}
    </RelatoriosDinamicosContext.Provider>
  );
};

export const useRelatoriosDinamicosContext = () => {
  const context = useContext(RelatoriosDinamicosContext);

  if (context === undefined || !context.service || !context.progressInterval) {
    throw new Error(
      'useRelatoriosDinamicosContext must be used within a RelatoriosDinamicosContextProvider'
    );
  }
  return context;
};
